import * as React from 'react'
import * as styles from './TextOverlay.module.scss'
import * as cn from 'classnames'
import checkUrlType from '../../../../utils/url-type-checker'
import { StorefrontLink as Link } from 'DVWebNodeUtils';

interface TwinHeroTextOverlayProps {
  title: string
  text: string
}

interface TextOverlayProps {
  title: string
  link: Link
  centerText?: boolean
  hasAltTheme?: boolean
  description?: string
}

export const TwinHeroTextOverlay = ({ title, text }: TwinHeroTextOverlayProps) => (
  <div className={styles.OverlayedTextBackground}>
    <div className={styles.OverlayedTextWrapper}>
      <div className={styles.OverlayedTextTitle}>{title}</div>
      {Boolean(text) &&
        text !== title &&
        <div>{text}</div>}
    </div>
  </div>
)

const TextOverlay = ({ title, link, centerText = false, hasAltTheme, description }: TextOverlayProps) => {
  const classNames = cn(
    styles.OverlayedTextBackground,
    { [styles.centerText]: centerText },
    { [styles.hasAltTheme]: hasAltTheme }
  )
  if (title) {
    if (link && link.url) {
      return (
        <a title={description} href={checkUrlType(link.url, 'TextOverlay')}>
          <div className={classNames}>
            <div className={styles.OverlayedTextWrapper}>
              {title}
            </div>
          </div>
        </a>
      )
    }
    return (
      <div className={classNames}>
        <div className={styles.OverlayedTextWrapper}>
          {title}
        </div>
      </div>
    )
  }
  return null
}

export default TextOverlay
